import { useLoggedUser } from '%context/LoggedUser';

export { useLoggedUser as useUser };
